import { atom } from "jotai";
import { atomFamily } from "jotai/utils";

import { determineAssetType, getAssetId, getAssetLink } from "../utils";
import { DefaultNodeData, NodeType } from "../types";

import { nodeAtomFamily } from "./nodeAtomFamily";

export const assetTypeAndLinkAtomFamily_SUSPENDS = atomFamily(
  (nodeId: string) => {
    const baseAtom = atom(async (get) => {
      const node = get(nodeAtomFamily(nodeId));
      const { data, type } = node;

      const assetType = determineAssetType(
        (data as DefaultNodeData).services,
        type as NodeType,
      );

      const assetId = getAssetId(data, assetType);
      const interfaceProjectId = (data as DefaultNodeData).projectId;

      const assetLink = getAssetLink({
        assetType,
        assetId,
        interfaceProjectId,
      });

      return {
        assetType,
        assetLink,
      };
    });

    baseAtom.debugLabel = `assetTypeAndLinkAtomFamily_SUSPENDS(${nodeId})`;
    return baseAtom;
  },
);
